<nav id="topmenu" class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container">
    <a class="navbar-brand" [routerLink]="routes.home">
      <img width="168" src="/assets/images/logo.svg" class="primary-logo" alt="WOW LOGO" />
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon-custom"></span>
    </button>
    @if(!sharedService.removeNavbarLinks){
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        @if(!isLoginPage && !isRegisterPage){
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ 'MENU.MEMBERSHIP' | translate }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <div class="menu-mobile-btn-container">
              <button>
                <img width="17" [src]="sharedService.imagesUrl +  'icons/dropdown-arrow.svg'" alt="DOWN ARROW">
              </button>
              <button>X</button>
            </div>
            <li>
              <a class="dropdown-item" [routerLink]="routes.plusMembership">{{ 'MENU.EVERYDAY_CARE' | translate: {
                tenant: 'WOW'} }}</a>
            </li>
            <li>
              <a class="dropdown-item" [routerLink]="routes.healthSharing">
                {{ 'MENU.HEALTH_SHARE_FOR_LARGE' | translate }}
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ 'MENU.FOR_MEMBERS' | translate }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <div class="menu-mobile-btn-container">
              <button>
                <img width="17" [src]="sharedService.imagesUrl +  'icons/dropdown-arrow.svg'" alt="DOWN ARROW">
              </button>
              <button>X</button>
            </div>
            <li><a class="dropdown-item" [routerLink]="routes.officeVisit">
                {{ 'MENU.OFFICE_VISITS' | translate }} </a></li>
            <li><a class="dropdown-item" [routerLink]="routes.virtualUrgentCare">
                {{ 'MENU.VIRTUAL_URGENT_CARE' | translate }}</a></li>
            <li>
              <a class="dropdown-item" [routerLink]="routes.mentalHealth">
                {{ 'MENU.MENTAL_HEALTH' | translate }}
              </a>
            </li>
            <li><a class="dropdown-item" [routerLink]="routes.pharmacy">{{ 'MENU.PHARMACY' | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.dental">{{ 'MENU.DENTAL_CARE' | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.visionService">{{ 'MENU.VISION_CARE' | translate }}</a>
            </li>
            <li><a class="dropdown-item" [routerLink]="routes.imaging">{{ 'MENU.IMAGING' | translate }}</a>
            </li>
            <li><a class="dropdown-item" [routerLink]="routes.labTest">{{ 'MENU.LAB_TESTS' | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.surgical">{{ 'MENU.PROCEDURES_SURGERIES' | translate
                }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.healthShare">{{ 'MENU.HEALTH_SHARE' | translate }}</a>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ 'MENU.RESOURCES' | translate }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <div class="menu-mobile-btn-container">
              <button>
                <img width="17"
                  [src]="sharedService.imagesUrl +  'icons/dropdown-arrow.svg'"
                  alt="DOWN ARROW">
              </button>
              <button>X</button>
            </div>
            <li><a class="dropdown-item" [routerLink]="routes.wowVideo">
                {{ 'MENU.VIDEOS' | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.blogs">{{ 'MENU.BLOGS' | translate }}</a>
            </li>
            <li><a class="dropdown-item" [routerLink]="routes.faqs">{{ 'MENU.FAQS' | translate }}</a></li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ 'MENU.ABOUT_US' | translate }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <div class="menu-mobile-btn-container">
              <button>
                <img width="17"
                  [src]="sharedService.imagesUrl +  'icons/dropdown-arrow.svg'"
                  alt="DOWN ARROW">
              </button>
              <button>X</button>
            </div>
            <li><a class="dropdown-item" [routerLink]="routes.aboutUs">{{ 'MENU.ABOUT_US' | translate }}</a></li>
            <li><a class="dropdown-item" [routerLink]="routes.contactUs">{{ 'MENU.CONTACT_US' | translate }}</a></li>
          </ul>
        </li>
        }
        <!-- <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            <img
              width="32"
              src="https://www.mywowhealth.com/wp-content/themes/docdirect-child/assets/images/profile_avatar.png"
              lt="" />
            Hi, Person!
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" href="/my-profile/">My Dashboard</a></li>
            <li><a class="dropdown-item" href="/logout/" style="color: #ff3232">Log Out</a></li>
          </ul>
        </li> -->


      </ul>
      <ul class="navbar-nav mb-2 mb-lg-0">
        @if(!isLoginPage && !isRegisterPage){
        <li class="nav-item">
          <a class="nav-link" [routerLink]="routes.employers">{{ 'MENU.FOR_EMPLOYERS' | translate }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="routes.advocates">{{ 'MENU.FOR_BROKERS' | translate }}</a>
        </li>
        @if(isUser){
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            <img width="32"
              [src]="sharedService.imagesUrl +  'icons/profile_avatar.png'"
              lt="" />
            Hi, {{user['display-name']}}!
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" [routerLink]="routes.dashboard">My Dashboard</a></li>
            <li><a class="dropdown-item" (click)="logout()" style="color: #ff3232">Log Out</a></li>
          </ul>
        </li>
        }
        }
        @if(!isUser){
        @if(isLoginPage){
        <li class="nav-item topbar-btn donthaveaccounttext">
          {{ 'MENU.REGISTER_INFO' | translate }}
        </li>
        }
        @if(isRegisterPage){
        <li class="nav-item topbar-btn donthaveaccounttext">
          {{ 'MENU.LOGIN_INFO' | translate }}
        </li>
        }
        @if(!isRegisterPage){
        <li class="nav-item topbar-btn">
          <a [routerLink]="routes.register" [class]="isLoginPage ? 'btn-primary' : 'btn-primary-clean'" class="btn "
            style="margin-right: 4px;">{{ 'MENU.REGISTER' | translate }}</a>
        </li>
        }
        @if(!isLoginPage){
        <li class="nav-item topbar-btn">
          <a [routerLink]="routes.login" class="btn btn-primary">{{ 'MENU.MEMBERLOGIN' | translate }}</a>
        </li>
        }
        }
      </ul>
    </div>
    }
  </div>
</nav>

<app-warning-block
        *ngIf="showFutureServiceErr"
        [heading]="('MEMBERSHIP_WARNING' | translate)"
        [message]="errMsg" (hideAction)="hideError($event)" 
        [containerStyle]="containerStyle" [msgBodyStyle]="msgBodyStyle"></app-warning-block>